import $ from 'jquery'

$(function () {
    isElementExist(".carousel", initCarousel);
    isElementExist(".review-slider", initReviewSlider);
    setTimeout(() => {
        isElementExist("#modalText", readMore);
    }, 1000);
    isElementExist(".employee-slider", initEmployeeSlider);
    isElementExist(".spotlight-slider", initSpotlightSlider);
});

// Helper if element exist then call function
function isElementExist(_el, _cb) {
    const elem = document.querySelector(_el);

    if (document.body.contains(elem)) {
        try {
            _cb();
        } catch (e) {
            console.log(e);
        }
    }
}


function initCarousel() {
    let carousels = document.querySelectorAll(".carousel");

    carousels.forEach(function (slider) {
        const carouselInner = slider.querySelector(".carousel-slider");
        const buttonNext = slider.querySelector(".swiper-button-next");
        const buttonPrev = slider.querySelector(".swiper-button-prev");

        const carousel = new Swiper(carouselInner, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            watchSlidesProgress: true,
            autoHeight: true,
            simulateTouch: false,

            navigation: {
                nextEl: buttonNext,
                prevEl: buttonPrev,
            },

            on: {
                slideChange: function (el) {
                    const youTubeVideo = slider.querySelectorAll("iframe");

                    if (youTubeVideo) {
                        youTubeVideo.forEach(function (video) {
                            video.src = video.src;
                        });
                    }
                },
            },
        });
    });
}

function initReviewSlider() {
    const reviewSliders = document.querySelectorAll(".review-slider");

    reviewSliders.forEach(function (slider) {
        const v2 = slider.classList.contains("_v2");
        const buttonNext = slider.querySelector(".swiper-button-next");
        const buttonPrev = slider.querySelector(".swiper-button-prev");

        const reviewSlider = new Swiper(slider, {
            slidesPerView: v2 ? 2 : 4,
            spaceBetween: v2 ? 60 : 35,
            loop: true,
            watchSlidesProgress: true,

            navigation: {
                nextEl: buttonNext,
                prevEl: buttonPrev,
            },

            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                640: {
                    slidesPerView: v2 ? 1 : 2,
                    spaceBetween: 25,
                },
                768: {
                    slidesPerView: v2 ? 2 : 2,
                    spaceBetween: 25,
                },
                960: {
                    slidesPerView: v2 ? 2 : 3,
                    spaceBetween: v2 ? 40 : 30,
                },
                1260: {
                    slidesPerView: v2 ? 2 : 4,
                    spaceBetween: v2 ? 60 : 35,
                },
            },
        });
    });
}

function initEmployeeSlider() {
    const employeeSliders = document.querySelectorAll(".employee-slider");

    employeeSliders.forEach(function (slider) {
        const buttonNext = slider.querySelector(".swiper-button-next");
        const buttonPrev = slider.querySelector(".swiper-button-prev");

        const reviewSlider = new Swiper(slider, {
            slidesPerView: 2,
            spaceBetween: 60,
            loop: true,
            watchSlidesProgress: true,

            navigation: {
                nextEl: buttonNext,
                prevEl: buttonPrev,
            },

            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                640: {
                    slidesPerView: 1,
                    spaceBetween: 25,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                },
                960: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                },
                1260: {
                    slidesPerView: 2,
                    spaceBetween: 60,
                },
            },
        });
    });
}

function initSpotlightSlider() {
    const spotlightSliders = document.querySelectorAll(".spotlight-slider");

    spotlightSliders.forEach(function (slider) {
        const buttonNext = slider.querySelector(".swiper-button-next");
        const buttonPrev = slider.querySelector(".swiper-button-prev");

        const spotlightSlider = new Swiper(slider, {
            slidesPerView: 4,
            spaceBetween: 30,
            loop: true,
            watchSlidesProgress: true,

            navigation: {
                nextEl: buttonNext,
                prevEl: buttonPrev,
            },

            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                640: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 25,
                },
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                1440: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            },
        });
    });
}

function readMore() {
    const readMoreButtons = document.querySelectorAll('.review-read-more');
    const modal = document.getElementById('reviewModal');
    const modalText = modal.querySelector('#modalText');
    const modalAuthor = modal.querySelector('#modalAuthor');
    const modalStars = modal.querySelector('#modalStars');
    const closeModal = modal.querySelector('.close');

    readMoreButtons.forEach(button => {
        button.addEventListener('click', function () {
            modalText.textContent = this.getAttribute('data-review');
            modalAuthor.textContent = this.getAttribute('data-author');
            const widthPercentage = (this.getAttribute('data-stars') / 5) * 100;
            modalStars.style.width = `calc(${widthPercentage}%)`;
            modal.style.display = 'block';
        });
    });

    closeModal.addEventListener('click', function () {
        modal.style.display = 'none';
    });

    window.addEventListener('click', function (event) {
        if (event.target === modal) {
            modal.style.display = 'none';
        }
    })
}